import classNames from "classnames";
import { isEmpty } from "lodash";
import React, { HTMLAttributes, forwardRef } from "react";

import FilterIcon from "ac-components/ac-icons/FilterIcon";

import "./ACTagColored.less";

type Colors =
  | "Primary"
  | "Success"
  | "Error"
  | "Warning"
  | "Moss"
  | "GreenLight"
  | "Green"
  | "BlueLight"
  | "Teal"
  | "Blue"
  | "Neutral"
  | "Yellow"
  | "Orange"
  | "Rose"
  | "Pink"
  | "Fuchsia"
  | "Purple"
  | "Violet"
  | "Indigo"
  | "BlueDark";

export { Colors as TagColors };

type ACTagProps = {
  label: string;
  color: Colors;
  secondaryLabelDelimiter?: string;
  onFilterClick?: (tag: string) => void;
  dot?: boolean;
  border?: boolean;
} & HTMLAttributes<HTMLSpanElement>;

const ACTagColored = forwardRef<HTMLSpanElement, ACTagProps>(function ACTag(
  {
    label,
    secondaryLabelDelimiter,
    onFilterClick,
    className,
    children,
    color = "Primary",
    dot = true,
    border,
    ...restSpanProps
  },
  ref,
) {
  const delimiter = secondaryLabelDelimiter;
  const primaryLabel =
    delimiter && label.includes(delimiter)
      ? label.split(delimiter)[0] + ":"
      : label;
  const secondaryLabel =
    delimiter && label.includes(delimiter)
      ? label.split(delimiter).slice(1).join(delimiter)
      : "";
  return (
    <span
      className={classNames(
        className,
        "ac-tag-colored text-small-highlight",
        color,
        {
          "ac-tag-colored-bordered": border,
        },
      )}
      {...restSpanProps}
      ref={ref}
    >
      {dot ? (
        <span className={classNames("ac-tag-colored-indicator", color)} />
      ) : null}
      {isEmpty(children) ? (
        <>
          {primaryLabel}
          {secondaryLabel ? (
            <span className="ac-tag-colored-secondary-label">
              {secondaryLabel}
            </span>
          ) : null}
        </>
      ) : (
        children
      )}
      {onFilterClick ? (
        <span
          className="ac-tag-colored-filter-icon"
          onClick={() => onFilterClick(label)}
        >
          <FilterIcon />
        </span>
      ) : null}
    </span>
  );
});

export default ACTagColored;
